import React, { useEffect, useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { fetchMyBookings, rescheduleOrCancelBooking } from "../../services/api";
import { BOOKING_STATUS } from "../../utils/constants";
import Loader from "../common/Loader";
import "../common/Account.css";

const statusLabel = {
  [BOOKING_STATUS.PENDING]: "Pending",
  [BOOKING_STATUS.IN_PROGRESS]: "In progress",
  [BOOKING_STATUS.COMPLETED]: "Completed",
  [BOOKING_STATUS.CANCELLED]: "Cancelled",
};

const MyBookings = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [acting, setActing] = useState(false);
  const [error, setError] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetchMyBookings();
      setList(Array.isArray(res?.data) ? res.data : []);
    } catch (err) {
      setError(err.message || "Failed to load bookings");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const cancelBooking = async (bookingId) => {
    if (!window.confirm("Cancel this booking?")) return;
    setActing(true);
    try {
      await rescheduleOrCancelBooking({
        bookingId,
        status: BOOKING_STATUS.CANCELLED,
      });
      await load();
    } catch (err) {
      setError(err.message || "Cancel failed");
    } finally {
      setActing(false);
    }
  };

  return (
    <div className="account-page">
      {(loading || acting) && (
        <Loader overlay message={acting ? "Updating..." : "Loading bookings..."} />
      )}
      <div className="coustom_container">
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h1 className="mb-0">My Bookings</h1>
          <Link to="/checkout" className="btn btn-kior">
            Book a test
          </Link>
        </div>
        {error && <Alert variant="danger">{error}</Alert>}
        <div className="account-card">
          {!loading && list.length === 0 && (
            <p className="text-muted mb-0">No bookings found.</p>
          )}
          {list.map((b) => (
            <div key={b._id} className="booking-item">
              <div className="d-flex justify-content-between flex-wrap gap-2">
                <div>
                  <h5>{b.bookingId || b._id}</h5>
                  <p className="mb-1 text-muted">
                    {b.bookingDate} · {b.bookingTime}
                  </p>
                  <p className="mb-1">
                    Amount: ₹{b.finalAmount ?? b.amount ?? 0}
                    {b.paymentMode === 1 ? " (Cash)" : b.paymentMode === 2 ? " (Online)" : ""}
                  </p>
                  <span className={`status-badge status-${b.status}`}>
                    {statusLabel[b.status] ?? b.status}
                  </span>
                </div>
                <div className="d-flex flex-column gap-2">
                  <Link
                    to={`/my-bookings/${b._id}`}
                    className="btn btn-sm btn-kior"
                  >
                    View details
                  </Link>
                  {b.status !== BOOKING_STATUS.CANCELLED &&
                    b.status !== BOOKING_STATUS.COMPLETED && (
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={() => cancelBooking(b._id)}
                      >
                        Cancel
                      </Button>
                    )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MyBookings;
